import React from "react";

// ASSETS
import ContactIcon from "assets/svg/ContactIcon.svg";
import PhoneIcon from "assets/svg/WhitePhoneIcon.svg";
import FaxIcon from "assets/svg/FaxIcon.svg";
import MailIcon from "assets/svg/MailIcon.svg";
// STYLES
import {
  ContactCardIcon,
  ContactCardIconWrapper,
  ContactCardSubtitleWrapper,
  ContactCardTextContainer,
  ContactCardTextWrapper,
  ContactCardTtileWrapper,
  ContactCardWrapper,
  ContactContainer,
  ContactInfoCardIcon,
  ContactInfoCardIconWrapper,
  ContactInfoCardTextContainer,
  ContactInfoCardTitleWrapper,
  ContactInfoCardValueWrapper,
  ContactInfoCardWrapper,
  ContactMapCardWrapper,
  ContactMapOverlay,
  ContactWrapper,
} from "./ContactStyled";

// LIBRARIES
import { useTranslation } from "react-i18next";

// MISC
import { CardType, IProps } from "./ContactModel";
import { TextType } from "components/Atoms/CustomText/CustomTextModel";
import { COLORS } from "constants/variables";

// REDUX
import { useSelector } from "react-redux";
import { accessibilityBiggerCursorSelector } from "slices/UISlice/uiSliceSelectors";

// COMPONENTS
import Map from "components/Map/Map";
import CustomText from "components/Atoms/CustomText/CustomText";

const Contact = (props: IProps) => {
  // PROPERTIES

  // LIBRARY CONSTANTS
  const { t } = useTranslation();
  const biggerCursor = useSelector(accessibilityBiggerCursorSelector);

  // STATE CONSTANTS
  const contactData = [
    {
      id: 0,
      title: t("view.contact.contactCards.phone"),
      value: "021.312.25.47",
      icon: PhoneIcon,
      type: CardType.PHONE,
    },
    {
      id: 1,
      title: t("view.contact.contactCards.central"),
      value: "021.303.70.80",
      icon: PhoneIcon,
      type: CardType.CENTER,
    },
    {
      id: 2,
      title: t("view.contact.contactCards.email"),
      value: "dsu@mai.gov.ro",
      icon: MailIcon,
      type: CardType.EMAIL,
    },
  ];

  const mapCenter = {
    lat: 44.43859,
    lng: 26.09807,
  };

  const marking = {
    lat: 44.43859,
    lng: 26.09807,
  };
  // API REQUESTS

  // LIFE CYCLE

  // EVENT HANDLERS
  const handleClick = () => {
    window.open("https://maps.app.goo.gl/p3hhsKkuAfLhBSGY7", "_blank");
  };

  return (
    <ContactContainer>
      <ContactWrapper>
        <ContactCardWrapper>
          <ContactCardTextContainer>
            <ContactCardTtileWrapper>
              <CustomText
                text={t("view.contact.cardTitle")}
                type={TextType.H2bold}
                color={COLORS.VividAuburn}
              />
            </ContactCardTtileWrapper>
            <ContactCardSubtitleWrapper>
              <CustomText
                text={t("view.contact.cardSubtitle")}
                type={TextType.H3}
                color={COLORS.RaisinBlack}
              />
            </ContactCardSubtitleWrapper>
            <ContactCardTextWrapper>
              <CustomText
                text={t("view.contact.scheduleTitle")}
                type={TextType.H4}
                color={COLORS.MetalicSilver}
              />
              <CustomText
                text={t("view.contact.scheduleSubtitle")}
                type={TextType.P1}
                color={COLORS.RaisinBlack}
              />
              <CustomText
                text={t("view.contact.audiencesTitle")}
                type={TextType.H4}
                color={COLORS.MetalicSilver}
              />
              <CustomText
                text={t("view.contact.audiencesSubtitle")}
                type={TextType.P1}
                color={COLORS.RaisinBlack}
              />
            </ContactCardTextWrapper>
          </ContactCardTextContainer>
          <ContactCardIconWrapper>
            <ContactCardIcon src={ContactIcon} />
          </ContactCardIconWrapper>
        </ContactCardWrapper>
        {contactData.map((contact) => (
          <ContactInfoCardWrapper key={contact.id} type={contact.type}>
            <ContactInfoCardTextContainer>
              <ContactInfoCardTitleWrapper>
                <CustomText
                  text={contact.title}
                  type={TextType.H5bold}
                  color={COLORS.Yellow}
                />
              </ContactInfoCardTitleWrapper>
              <ContactInfoCardValueWrapper>
                <CustomText
                  text={contact.value}
                  type={TextType.H3}
                  color={COLORS.Background}
                />
              </ContactInfoCardValueWrapper>
            </ContactInfoCardTextContainer>
            <ContactInfoCardIconWrapper>
              <ContactInfoCardIcon src={contact.icon} />
            </ContactInfoCardIconWrapper>
          </ContactInfoCardWrapper>
        ))}
        <ContactMapCardWrapper>
          <ContactMapOverlay biggerCursor={biggerCursor} onClick={handleClick}>
            <CustomText
              text={t("view.contact.contactCards.address")}
              type={TextType.H5bold}
              color={COLORS.Yellow}
            />
            <CustomText
              text={t("view.contact.contactCards.addressValue")}
              type={TextType.H3}
              color={COLORS.Background}
            />
          </ContactMapOverlay>
          <Map mapCenter={mapCenter} marking={marking} zoom={17} />
        </ContactMapCardWrapper>
        <ContactInfoCardWrapper type={CardType.FAX}>
          <ContactInfoCardTextContainer>
            <ContactInfoCardTitleWrapper>
              <CustomText
                text={t("view.contact.contactCards.fax")}
                type={TextType.H5bold}
                color={COLORS.Yellow}
              />
            </ContactInfoCardTitleWrapper>
            <ContactInfoCardValueWrapper>
              <CustomText
                text="021.312.25.47"
                type={TextType.H3}
                color={COLORS.Background}
              />
            </ContactInfoCardValueWrapper>
          </ContactInfoCardTextContainer>
          <ContactInfoCardIconWrapper>
            <ContactInfoCardIcon src={FaxIcon} />
          </ContactInfoCardIconWrapper>
        </ContactInfoCardWrapper>
      </ContactWrapper>
    </ContactContainer>
  );
};

export default Contact;
